import { render, staticRenderFns } from "./to_be_verified.vue?vue&type=template&id=0bc39047&"
import script from "./to_be_verified.vue?vue&type=script&lang=js&"
export * from "./to_be_verified.vue?vue&type=script&lang=js&"
import style0 from "./to_be_verified.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports